export const createHeartGrantIdempotencyKey = (userId) => {
    const randomPart = (typeof window !== 'undefined' && window.crypto?.randomUUID?.()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    return `heart-${userId}-${randomPart}`.slice(0, 64);
};
